let galleryFeatured = {
    sel: '#featured-panels-slides',

    init: function () {
        let self = this
        let sel = $(this.sel)

        let numSlides = $(this.sel + ' .featured-panel').length
        numSlides
        sel.addClass('num-slides-'+numSlides)

        //listeners
        sel.on('init', this.galleryInit)
        //sel.on('beforeChange', this.galleryBeforeChange)
        //sel.on('afterChange', this.galleryAfterChange)

        //start it
        sel.slick({
            infinite: true,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 4000,
            //vertical: true,
            rows:0,
            appendDots:'#featured-panels-dots',
            responsive: [
                {
                    breakpoint: 0,
                    settings: {

                    }
                },
            ]
        })

    },//init

    galleryInit: function() {
        $('#featured-panels').css('opacity',1)
    },
    galleryBeforeChange: function (event, slick, currentSlide, nextSlide) {

    },
    galleryAfterChange: function (event, slick, currentSlide) {

    },

    revealSlide:function () {
        let tl = gsap.timeline({onComplete: bookingWidget.tabClickAnimateIn})
        tl.fromTo(sectionSel, {y:0}, {duration: 0.15, y: -150, stagger:0.05, ease:Linear.easeNone})
    }
}
export default galleryFeatured